import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TermsAndPoliciesContent from './TermsAndPoliciesContent';
import { enhance } from './enhance';

const TermsAndPolicies = ({ className, text, textLink, document }) => {
  const [showDocument, toggleDocument] = useState(false);

  const handleClickDocument = e => {
    e.preventDefault();
    toggleDocument(true);
  };

  return (
    <div styleName="root" className={className}>
      {text && <span styleName="text">{text}</span>}
      <span styleName="textLink" onClick={handleClickDocument}>
        {textLink}
      </span>
      {showDocument && (
        <TermsAndPoliciesContent
          title={textLink}
          document={document}
          onClose={() => toggleDocument(false)}
        />
      )}
    </div>
  );
};

TermsAndPolicies.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  textLink: PropTypes.string,
  document: PropTypes.node,
};

export default enhance(TermsAndPolicies);



// WEBPACK FOOTER //
// ./src/components/common/TermsAndPolicies/index.jsx